import notification from "@/utils/notifications.js"; // Импортируем менеджер уведомлений

/**
 * Обработка ошибок API
 */
export const handleApiError = (error, moduleName, defaultMessage = 'Ошибка при выполнении запроса') => {
  console.error(moduleName, `❌ Ошибка API: ${error.message || error}`);

  let errorMessage = defaultMessage;
  let statusCode = null;

  if (error.response) {
    statusCode = error.response.status;
    console.log(moduleName, `📊 Код ошибки: ${statusCode}`);

    switch (statusCode) {
      case 400:
        errorMessage = error.response.data?.detail || 'Некорректные данные';
        break;
      case 401:
        errorMessage = 'Требуется авторизация';
        break;
      case 403:
        errorMessage = error.response.data?.detail || 'Недостаточно прав';
        break;
      case 404:
        errorMessage = 'Ресурс не найден';
        break;
      case 409:
        errorMessage = error.response.data?.detail || 'Конфликт данных';
        break;
      case 422:
        const details = error.response.data?.detail;
        if (Array.isArray(details)) {
          const messages = details.map(d => `${d.loc?.join('.')}: ${d.msg}`).join(', ');
          errorMessage = `Ошибки валидации: ${messages}`;
        } else if (typeof details === 'string') {
          errorMessage = details;
        }
        break;
      case 500:
        errorMessage = 'Внутренняя ошибка сервера';
        break;
      default:
        errorMessage = error.response.data?.detail || `Ошибка ${statusCode}`;
    }
  } else if (error.request) {
    errorMessage = 'Сервер не отвечает. Проверьте подключение.';
  } else {
    errorMessage = error.message || 'Ошибка при выполнении запроса';
  }
  errorMessage = error.response?.data?.detail || errorMessage
  return { errorMessage, statusCode };
};

/**
 * Стандартная обработка успешного ответа с уведомлением
 */
export const handleSuccessResponse = (response, moduleName, operation = 'Операция', showNotification = true) => {
  console.log(moduleName, `✅ ${operation} успешно:`, response.data);

  // Показываем уведомление об успехе
  if (showNotification) {
    const message = response.data?.message || `${operation} выполнена успешно`;
    notification.success(message, 'Успешно');
  }

  return {
    success: true,
    data: response.data,
    error: null,
    status: response.status,
    timestamp: new Date().toISOString()
  };
};

/**
 * Стандартная обработка ошибки с уведомлением
 */
export const handleErrorResponse = (error, moduleName, operation = 'Операция', showNotification = true) => {
  const { errorMessage, statusCode } = handleApiError(error, moduleName, `Ошибка при ${operation}`);

  // Показываем уведомление об ошибке
  if (showNotification) {
    notification.error(errorMessage, 'Ошибка');
  }

  return {
    success: false,
    error: errorMessage,
    status: statusCode,
    data: null,
    timestamp: new Date().toISOString()
  };
};
